import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const IntroductionTextWrapper = styled.section`
  padding: 40px 0 40px;
  text-align: center;
  background: rgb(${getToken('color-background-tertiary')});

  ${screen.md} {
    padding: 40px 0px;
  }

  ${screen.lg} {
    padding: 69px 0 72px;
  }

  ${screen.xxlg} {
    padding: 100px 0 104px;
  }
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 316px;
  margin: 0 auto;

  ${screen.md} {
    max-width: 674px;
  }

  ${screen.lg} {
    max-width: 970px;
  }

  ${screen.xxlg} {
    max-width: 1380px;
  }
`;

export const Title = styled.h1`
  margin: 0 auto;
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-success-100')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 38px;
  line-height: 47px;
  text-align: center;
  margin-bottom: 32px;

  ${screen.md} {
    font-size: 48px;
    line-height: 60px;
  }

  /* ${screen.lg} {
    br {
      display: none;
    }
  } */
`;

export const Content = styled.p`
  margin: 0 10px;
  font-family: ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-regular')};
  font-size: 14px;
  line-height: 21px;

  text-align: center;

  ${screen.md} {
    font-size: 20px;
    line-height: 36px;
    margin: 0 28px;
  }

  ${screen.lg} {
    margin: 0 13px;
  }

  ${screen.xxlg} {
    margin: 0 20px;
  }
`;
